<template>
  <div class='tablePage'>
    <el-table stripe v-loading='loading' ref='multipleTable' :data='tableData' tooltip-effect='dark'
              style='width: 100%' :header-cell-style='headCellStyle' :height='tableHeight'
              @selection-change='handleSelectionChange'>
      <el-table-column type='selection' width='50' />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='name' :label="$t('public.table_code')" show-overflow-tooltip width='200'>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['relayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status === ENUM_DEVICE_STATUS.OFFLINE}">
                           {{ device.relayCode }}
                        </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>
      <!--            <el-table-column prop="sceneName" :label="$t('public.table_arch')" show-overflow-tooltip />-->
      <el-table-column prop='carrierName' width='200' :label="$t('public.table_carrier')" show-overflow-tooltip>
        <template #default='{ row }'>
          <CardSwipper :list='[row]' v-if='row.carrierName'>
            <template #title='{ item }'>
              {{ item.sceneName }}
            </template>
            <template #default={item}>
              <div class='uk-flex'>
                <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                  <i class='uk-margin-remove'
                     @click='carrierDetailFn(row)'
                     v-icon="['carrierTypeConvert',row.carrierType]"></i>
                </div>
                <div class='uk-flex-1'>
                  {{ item.carrierName }}
                </div>
              </div>
            </template>
          </CardSwipper>

        </template>
      </el-table-column>
      <el-table-column prop='updateTime' :label="$t('device.stop_time')" show-overflow-tooltip>
        <template #default='{ row }'>
          <span>{{ $timetransition(row.stopTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>

      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')" width='140'>
        <template #default='{ row }'>
          <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                     :icon='item.icon' @click='handle(item.method, row)'></el-button>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import prover from '../components/Proper.vue'
import { carrierTypeConvert, configStatusConvert, equiStatusConvert, relayTypeConvert } from '@/utils/convert'
import { getIsSys } from '@/utils/permission'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import item from '../../../../components/Menu/Item.vue'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'

export default {
  computed: {
    ENUM_DEVICE_STATUS () {
      return ENUM_DEVICE_STATUS
    },
    item () {
      return item
    }
  },
  props: ['loading', 'tableData'],
  components: {
    DeviceCode,
    CardSwipper,
    'v-popoer': prover
  },
  data () {
    return {
      relayTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('integration.modify_customer'),
          icon: 'el-icon-edit-outline',
          vHas: [],
          method: 'editScopeRowFn'
        },
        {
          id: 5,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        },

        {
          id: 4,
          title: 'device.reuse',
          icon: 'el-icon-refresh-right',
          vHas: [],
          method: 'useAgainRowFn'
        },
        {
          id: 2,
          title: $t('public.tbopt_delete'),
          icon: 'el-icon-delete',
          vHas: [],
          method: 'delRowFn'
        }

      ],

      isSys: true,
      isLoading: false,
      dialogVisible: false,
      carrierDetail: null
    }
  },

  mounted () {
    this.isSys = getIsSys()
  },

  methods: {
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },
    /** 查找监测点详情 */
    carrierDetailFn (row) {
      this.$emit('carrierDetailFn', row)
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
